import { createSlice } from '@reduxjs/toolkit'

const datasetSlice = createSlice({
    name: 'dataset',
    initialState: [],
    reducers:{
        init(state,action){
            return [
                ...action.list
            ]
        },
        getDatasetByName(state,action){
            let dataset = state.find(obj => obj.dataSetName === action.name)
            if(dataset) return dataset
            return null
        },
        refresh(){

        }
    }
})

export const datasetActions = datasetSlice.actions

export default datasetSlice.reducer